/** Permission keys granted by business admin → dashboard routes (must match App.js route guard). */
export const FRANCHISEE_OPERATOR_PERMISSION_ROUTES = {
  bill_access: [
    '/bills/create',
    '/bills/drafts',
    '/bills/cart-model',
    '/bills/view',
    '/bills/advance-bills',
    '/bills/operator-calls',
    // Citizen redeem → Mitra cart bill (same inbox as coupon_management).
    '/shop-orders',
  ],
  counter_stats: ['/bills/service-charges', '/bills/counter-sales-datewise'],
  coupon_management: ['/coupons', '/bills/post-bill-coupons', '/shop-orders'],
  customer_search: ['/customer/search', '/customer/dashboard'],
  pending_works: ['/bills/pending-works'],
  enquiries: ['/bills/enquiries', '/bills/enquiry-form', '/application-chat'],
  view_reports: ['/backup'],
  ads_management: ['/locsy/ads'],
};

export const FRANCHISEE_OPERATOR_ALWAYS_ALLOWED_PATHS = [
  '/locsy/dashboard',
  '/profile',
  '/bills/whatsapp-config',
];

export const normalizeFranchiseeOperatorPermissions = (permissions) =>
  Array.isArray(permissions) ? permissions.filter(Boolean) : [];

export const getFranchiseeOperatorAllowedPaths = (permissions) => {
  const keys = normalizeFranchiseeOperatorPermissions(permissions);
  const fromPermissions = keys.flatMap(
    (key) => FRANCHISEE_OPERATOR_PERMISSION_ROUTES[key] || [],
  );
  return [...new Set([...FRANCHISEE_OPERATOR_ALWAYS_ALLOWED_PATHS, ...fromPermissions])];
};

export const franchiseeOperatorCanAccessPath = (permissions, path) => {
  if (!path) return false;
  const allowed = getFranchiseeOperatorAllowedPaths(permissions);
  return allowed.some(
    (route) => path === route || path.startsWith(`${route}/`),
  );
};

export const hasFranchiseeOperatorPermission = (permissions, permissionKey) =>
  normalizeFranchiseeOperatorPermissions(permissions).includes(permissionKey);
